export const BROADCAST_MESSAGE = 'BROADCAST_MESSAGE';
export const SHOW_MESSAGE_TO_CLIENT = 'SHOW_MESSAGE_TO_CLIENT';
export const CLOSE_MESSAGE_MODAL = 'CLOSE_MESSAGE_MODAL';
